<template>
  <div>
    <!-- Page Title Section -->
    <div class="app-title">
      <div>
        <h1><i class="fas fa-list"></i> ตารางนอกเวลาราชการ {{ userId }}</h1>
        <p>[{{ reportName }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>

    <!-- Navbar with Filters -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-4">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <!-- Dropdowns or additional menu items can be added here -->
        </ul>

        <div class="form-inline mr-2">
          <label class="mr-2">เลือกปี</label>
          <select v-model="selectedYear" class="custom-select">
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>

        <!-- Month Selection -->
        <form class="form-inline my-2 my-lg-0">
          <div class="form-group mr-2">
            <label class="mr-2" for="monthSelect">เลือกเดือน</label>
            <select
              v-model="selectedMonth"
              class="custom-select"
              id="monthSelect"
            >
              <option
                :value="month.id"
                v-for="(month, index) in months"
                :key="index"
              >
                {{ month.name }}
              </option>
            </select>
          </div>
        </form>

        <!-- User Search -->
        <form @submit.prevent="" class="form-inline my-2 my-lg-0">
          <div class="form-group mr-2">
            <label class="mr-2" for="userSelect">ค้นหาเจ้าหน้าที่</label>
            <select
              v-model="selectedUserId"
              class="custom-select"
              id="userSelect"
            >
              <option
                :value="user.id"
                v-for="(user, index) in users"
                :key="index"
              >
                {{ user.name }}
              </option>
            </select>
          </div>
          <button
            @click="
              fetchReportData(selectedMonth, selectedUserId, selectedYear)
            "
            class="btn btn-outline-success my-2 my-sm-0"
            type="button"
          >
            ค้นหา
          </button>
        </form>
      </div>
    </nav>

    <!-- Report Table Section -->
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">ตารางปฏิบัติงาน</h3>
            <p>
              <button
                @click="printReport"
                type="button"
                class="btn btn-outline-success m-1"
              >
                <i class="fas fa-print"></i> Print
              </button>
              <button
                @click="exportToExcel"
                type="button"
                class="btn btn-outline-primary m-1"
              >
                <i class="fas fa-file-excel"></i> Export to Excel
              </button>
            </p>
          </div>
          <div class="tile-body">
            <div id="printMe">
              <div class="text-center">
                <p class="h4">
                  ตารางปฏิบัติงานนอกเวลาราชการ กลุ่มภารกิจสุขภาพดิจิทัล
                </p>
                <p class="h5">โรงพยาบาลวานรนิวาส จังหวัดสกลนคร</p>
              </div>
              <table class="table table-bordered">
                <thead class="bg-light text-center">
                  <tr>
                    <th>ลำดับ</th>
                    <th>วันที่</th>
                    <th>ชื่อ</th>
                    <th>ภาระงาน/กิจกรรมที่ปฎิบัติ</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Check if dataReport is not empty, and if so, render rows -->
                  <tr v-if="dataReport.length === 0">
                    <td colspan="4" class="text-center">ไม่พบข้อมูล</td>
                  </tr>
                  <!-- Render data rows when there are items in dataReport -->
                  <tr v-for="(item, index) in dataReport" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.created_at | formatDate }}</td>
                    <td>
                      <div v-if="item.user">
                        <p>{{ item.user.name }}</p>
                        <p>{{ item.user.position }}</p>
                      </div>
                      <div v-else>-</div>
                    </td>
                    <td>
                      <p>
                        ชื่อผู้ใช้งาน: <span>{{ item.end_user }}</span>
                      </p>
                      <p>
                        หน่วยงาน:
                        <span>{{
                          item.department
                            ? item.department.department_name
                            : "-"
                        }}</span>
                      </p>
                      <p>
                        รายละเอียด: <span>{{ item.description }}</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsersService from "../services/users.service";
import moment from "moment";
import httpCommon from "../services/http-common";
import * as XLSX from "xlsx"; // Importing the xlsx library

export default {
  computed: {
    currentUser() {
      return this.$store.getters.user;
    },
    userId() {
      return this.$store.getters.user?.id || null;
    },
  },
  data() {
    return {
      reportUser: null,
      dataReport: [],
      selectedUserId: "",
      selectedMonth: moment().format("MM"),
      selectedYear: moment().format("YYYY"),
      users: [],
      years: [],
      reportName: this.$route.name,
      currentMonth: moment().format("MM"),
      months: [
        { id: "01", name: "มกราคม" },
        { id: "02", name: "กุมภาพันธ์" },
        { id: "03", name: "มีนาคม" },
        { id: "04", name: "เมษายน" },
        { id: "05", name: "พฤษภาคม" },
        { id: "06", name: "มิถุนายน" },
        { id: "07", name: "กรกฎาคม" },
        { id: "08", name: "สิงหาคม" },
        { id: "09", name: "กันยายน" },
        { id: "10", name: "ตุลาคม" },
        { id: "11", name: "พฤศจิกายน" },
        { id: "12", name: "ธันวาคม" },
      ],
    };
  },
  methods: {
    loadReport() {
      this.fetchReportData(
        this.selectedMonth,
        this.selectedUserId,
        this.selectedYear
      );
    },
    async getUserDetails(id) {
      const res = await httpCommon.get(`user/${id}`);
      this.reportUser = res.data;
    },
    async fetchReportData(month, userId, year) {
      try {
        const res = await httpCommon.get(
          `month/${month}?user=${userId}&year=${year}`
        );

        this.dataReport = res.data;
      } catch (err) {
        console.error(err);
        this.dataReport = [];
      }
    },
    async fetchUsers() {
      try {
        const res = await UsersService.getAll();

        console.log("users:", res.data);

        this.users = res.data.data ?? res.data;
      } catch (error) {
        console.error("Load users error:", error);
      }
    },
    async printReport() {
      await this.$htmlToPaper("printMe");
    },
    exportToExcel() {
      const exportData = this.dataReport.map((item, index) => ({
        ลำดับ: index + 1,
        วันที่: moment(item.created_at).format("DD-MM-YYYY"),
        ชื่อ: item.user ? item.user.name : "",
        หน่วยงาน: item.department?.department_name || "",
        ผู้แจ้ง: item.end_user,
        รายละเอียด: item.description,
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const timestamp = moment().format("YYYYMMDD_HHmmss");
      const filename = `report-it-service-${timestamp}.xlsx`;

      XLSX.writeFile(wb, filename);
    },
  },
  watch: {
  userId: {
    immediate: true,
    handler(val) {
      if (val) {
        this.selectedUserId = val;
        this.loadReport();
      }
    }
  },

  selectedMonth() {
    this.loadReport();
  },

  selectedYear() {
    this.loadReport();
  }
},
  created() {
    const currentYear = moment().year();

    for (let i = -3; i <= 3; i++) {
      this.years.push(currentYear + i);
    }

    this.fetchUsers();
  },
};
</script>

<style scoped>
/* You can add custom styles here if needed */
</style>
